<template>
    <div class="page-table tabStyle scrollable mainDiv" id="affix-container">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.referans.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.referans.guncelleme.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.referans.guncelleme.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="referansForm" :rules="rulesReferans" ref="referansForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.referans.guncelleme.resim")'
                                                      prop="image">:
                                            <el-upload
                                                    action=""
                                                    :auto-upload="false"
                                                    :limit="1"
                                                    :on-change="imageUpload"
                                                    :on-remove="imageRemove"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref="upload"
                                                    list-type="picture-card">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="18" :md="18" :sm="24" :xs="24" class="col-p">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.musteri")'
                                                        prop="musteri">:
                                                    <el-input v-model="referansForm.musteri"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.musteriPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.sektor")'
                                                        prop="sektor">:
                                                    <el-input v-model="referansForm.sektor"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.sektorPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.referans.guncelleme.baslik")'
                                                              prop="baslik">:
                                                    <el-input
                                                            v-model="referansForm.baslik"
                                                            :placeholder='$t("src.views.apps.referans.guncelleme.baslikPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.proje")'
                                                        prop="proje">:
                                                    <el-input v-model="referansForm.proje"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.projePlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.referansTarihi")'
                                                        prop="referansTarihi">:
                                                    <el-input v-model="referansForm.referansTarihi"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.referansTarihiPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.referans.guncelleme.icerik")'
                                                              prop="icerik">:
                                                    <ckeditor :editor="editor"
                                                              :config="editorConfig"
                                                              v v-model="referansForm.icerik"></ckeditor>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.referans.guncelleme.resim")'
                                                      prop="image">:
                                            <el-upload
                                                    action=""
                                                    :auto-upload="false"
                                                    :limit="1"
                                                    :on-change="imageUpload"
                                                    :on-remove="imageRemove"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref="upload"
                                                    list-type="picture-card">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="18" :md="18" :sm="24" :xs="24" class="col-p">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.musteri")'
                                                        prop="musteri">:
                                                    <el-input v-model="referansForm.musteri"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.musteriPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.en.sektor")'
                                                        prop="dil.en.sektor">:
                                                    <el-input v-model="referansForm.dil.en.sektor"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.sektorPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.en.baslik")'
                                                        prop="dil.en.baslik">:
                                                    <el-input
                                                            v-model="referansForm.dil.en.baslik"
                                                            :placeholder='$t("src.views.apps.referans.guncelleme.baslikPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.en.proje")'
                                                        prop="dil.en.proje">:
                                                    <el-input v-model="referansForm.dil.en.proje"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.projePlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.en.referansTarihi")'
                                                        prop="dil.en.referansTarihi">:
                                                    <el-input v-model="referansForm.dil.en.referansTarihi"
                                                              placeholder='January 2020'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.en.icerik")'
                                                        prop="dil.en.icerik">:
                                                    <ckeditor :editor="editor"
                                                              :config="editorConfig"
                                                              v v-model="referansForm.dil.en.icerik"></ckeditor>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.referans.guncelleme.resim")'
                                                      prop="image">:
                                            <el-upload
                                                    action=""
                                                    :auto-upload="false"
                                                    :limit="1"
                                                    :on-change="imageUpload"
                                                    :on-remove="imageRemove"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref="upload"
                                                    list-type="picture-card">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="18" :md="18" :sm="24" :xs="24" class="col-p">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.musteri")'
                                                        prop="musteri">:
                                                    <el-input v-model="referansForm.musteri"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.musteriPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.de.sektor")'
                                                        prop="dil.de.sektor">:
                                                    <el-input v-model="referansForm.dil.de.sektor"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.sektorPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.de.baslik")'
                                                        prop="dil.de.baslik">:
                                                    <el-input
                                                            v-model="referansForm.dil.de.baslik"
                                                            :placeholder='$t("src.views.apps.referans.guncelleme.baslikPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.de.proje")'
                                                        prop="dil.de.proje">:
                                                    <el-input v-model="referansForm.dil.de.proje"
                                                              :placeholder='$t("src.views.apps.referans.guncelleme.projePlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.de.referansTarihi")'
                                                        prop="dil.de.referansTarihi">:
                                                    <el-input v-model="referansForm.dil.de.referansTarihi"
                                                              placeholder='Januar 2020'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.referans.guncelleme.dil.de.icerik")'
                                                        prop="dil.de.icerik">:
                                                    <ckeditor :editor="editor"
                                                              :config="editorConfig"
                                                              v v-model="referansForm.dil.de.icerik"></ckeditor>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.referans.guncelleme.durum")'>
                            <el-row>
                                <el-button size="mini" class="onayBtn"
                                           v-on:click="referansGuncelle('referansForm')"
                                           type="primary">
                                    {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                </el-button>
                                <el-button
                                        size="mini" @click="$router.go(-1)"
                                        class="onayBtn">
                                    Vazgeç
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.referans.guncelleme.link")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="link">
                                        <el-input v-model="referansForm.link"
                                                  :placeholder='$t("src.views.apps.referans.guncelleme.linkPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.referans.guncelleme.yer")' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="yer">
                                        <el-input v-model="referansForm.yer"
                                                  placeholder="Sivas Merkez"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import CKEditor from '@ckeditor/ckeditor5-vue';
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import '@ckeditor/ckeditor5-build-classic/build/translations/tr';

    Vue.use(CKEditor)
    import referansService from '../../../WSProvider/ReferansService'
    import status from '../../../status'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataArtdoor = "";
    export default {
        name: "ReferansDuzenle",
        components: {
            ckeditor: CKEditor.component
        },
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.updateReferansKodu = window.location.search.slice(1).split("=")[1];
                this.getReferansDetay(this.updateReferansKodu);
            }
        },
        data() {
            return {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3'],
                visibleSil: false,
                checked: true,
                updateReferansKodu: '',
                referansDetayKlon: [],
                updateData: [],
                updateDataEN: [],
                updateDataDE: [],
                referansForm: {
                    baslik: '',
                    link: '',
                    durum: "1",
                    musteri: '',
                    sektor: '',
                    image: '',
                    imageBase: '',
                    icerik: '',
                    proje: '',
                    referansTarihi: '',
                    yer: '',
                    dil: {
                        en: {
                            sektor: '',
                            baslik: '',
                            proje: '',
                            referansTarihi: '',
                            icerik: ''
                        },
                        de: {
                            sektor: '',
                            baslik: '',
                            proje: '',
                            referansTarihi: '',
                            icerik: ''
                        }
                    }
                },
                rulesReferans: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    musteri: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            // inputStyle(val, form) {
            //     var splitStr = val.toLowerCase().split(' ');
            //     for (var i = 0; i < splitStr.length; i++) {
            //         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            //     }
            //     this.referansForm[form] = splitStr.join(' ');
            // },
            imageRemove() {
                $('.el-upload--picture-card').show();
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.referansForm.musteri) {
                        var imgname = randomText(13) + '-' +linkTemizle(this.referansForm.musteri)+".png";
                    } else {
                        imgname = randomText(13) + '-' +linkTemizle(file.name.split('.')[0])+".png";
                    }
                    this.referansForm.image = imgname;
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            this.referansForm.imageBase = e.target.result;
                        }
                        reader.readAsDataURL(files);
                    }
                } else {
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            getReferansDetay(referansKodu) {
                referansService.referansDetay(referansKodu).then((response) => {
                    if (response.status === 200) {
                        // console.log(response);
                        for (var key in response.data) {
                            this.referansForm[key] = response.data[key];
                            this.referansDetayKlon = JSON.stringify(response.data);
                        }
                    } else {
                        status.Status(response.status, this);
                    }
                })
            },

            referansGuncelle(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        for (var key in JSON.parse(this.referansDetayKlon)) {
                            if (key !== 'dil') {
                                if (JSON.parse(this.referansDetayKlon)[key] !== this.referansForm[key]) {
                                    if (this.referansForm[key]) {
                                        var item = {
                                            type: key,
                                            value: this.referansForm[key]
                                        };
                                        this.updateData.push(item);
                                    }
                                }
                            } else if (key === 'dil') {
                                for (var keyDil in JSON.parse(this.referansDetayKlon).dil.en) {
                                    if (JSON.parse(this.referansDetayKlon).dil.en[keyDil] !== this.referansForm.dil.en[keyDil]) {
                                        if (this.referansForm.dil.en[keyDil]) {
                                            var itemEn = {
                                                type: keyDil,
                                                value: this.referansForm.dil.en[keyDil]
                                            };
                                            this.updateDataEN.push(itemEn);
                                        }
                                    }
                                }
                                for (var keyDil in JSON.parse(this.referansDetayKlon).dil.de) {
                                    if (JSON.parse(this.referansDetayKlon).dil.de[keyDil] !== this.referansForm.dil.de[keyDil]) {
                                        if (this.referansForm.dil.de[keyDil]) {
                                            var itemDe = {
                                                type: keyDil,
                                                value: this.referansForm.dil.de[keyDil]
                                            };
                                            this.updateDataDE.push(itemDe);
                                        }
                                    }
                                }
                                if (this.updateDataEN.length!==0 || this.updateDataDE.length!==0) {
                                    this.updateData.push({
                                        type: "dil",
                                        value: {
                                            en: this.updateDataEN,
                                            de: this.updateDataDE,
                                        }
                                    })
                                }
                            }
                        }
                        // console.log(this.updateData)
                        referansService.referansGuncelle(this.updateReferansKodu, this.updateData).then((response) => {
                            if (response.status === 200) {
                                status.Status('success', this, 'Referans başarıyla güncellendi.');
                                this.$refs[formName].resetFields();
                                $('.el-upload-list__item-delete').click();
                                history.back();
                            }
                            if (response.status === 230) {
                                status.Status('warning', this, 'Bu bilgiler ile kayıtlı bir referans zaten mevcut');

                            } else {
                                status.Status(response.status, this)
                            }
                        })
                    }
                })
            },
        }
    }
    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }
    function linkTemizle(text)
    {
        var trMap = {
            'çÇ':'c',
            'ğĞ':'g',
            'şŞ':'s',
            'üÜ':'u',
            'ıİ':'i',
            'öÖ':'o'
        };
        for(var key in trMap) {
            text = text.replace(new RegExp('['+key+']','g'), trMap[key]);
        }
        return  text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }
    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>
<style scoped>
    #affix-container.tabStyle {
        position: relative;
        padding-left: 55px;
        left: -30px;
    }
</style>
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';
    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>